import DashboardIcon from "../assets/icons/dashboard.png";
import UserManagementIcon from "../assets/icons/Users.png";
import OperationsIcon from "../assets/icons/Financial Statement.png";
import StaffManagementIcon from "../assets/icons/Management.png";
import PlatformManagementIcon from "../assets/icons/Projects.png";

export const ADMIN_PAGE_LABELS = Object.freeze({
  admins: "Admins",
  roles: "Roles",
  role: "Role",
  selectRole: "Select Role",
  globalSettings: "Global Settings",
  countriesCities: "Countries & Cities",
  merchantCategories: "Merchant Categories",
  merchantPaymentMethods: "Merchant Payment Methods",
  appBanners: "App Banners"
});

const navigationLabels = {
  en: {
    dashboard: "Dashboard",
    userManagement: "User Management",
    userManagementPages: "User Management pages",
    customers: "Customers",
    merchants: "Merchants",
    registrationReviews: "Registration Reviews",
    installmentOperations: "Installment Requests",
    staffManagement: "Staff Management",
    staffManagementPages: "Staff Management pages",
    admins: "Admins",
    roles: "Roles",
    platformManagement: "Platform Management",
    platformManagementPages: "Platform Management pages",
    globalSettings: "Global Settings",
    countriesCities: "Countries & Cities",
    merchantCategories: "Merchant Categories",
    merchantPaymentMethods: "Merchant Payment Methods",
    appBanners: "App Banners"
  },
  ar: {
    dashboard: "لوحة التحكم",
    userManagement: "إدارة المستخدمين",
    userManagementPages: "صفحات إدارة المستخدمين",
    customers: "العملاء",
    merchants: "التجار",
    registrationReviews: "مراجعات التسجيل",
    installmentOperations: "طلبات التقسيط",
    staffManagement: "إدارة فريق العمل",
    staffManagementPages: "صفحات إدارة فريق العمل",
    admins: "المشرفون",
    roles: "الأدوار",
    platformManagement: "إدارة المنصة",
    platformManagementPages: "صفحات إدارة المنصة",
    globalSettings: "الإعدادات العامة",
    countriesCities: "الدول والمدن",
    merchantCategories: "فئات التجار",
    merchantPaymentMethods: "طرق دفع التجار",
    appBanners: "لافتات التطبيق"
  }
};

const link = (key, label, path, icon) => ({
  type: "link",
  key,
  label,
  path,
  icon
});

const group = (key, label, pagesLabel, icon, children) => ({
  type: "group",
  key,
  label,
  pagesLabel,
  icon,
  children
});

export const getAdminNavigation = (language = "en") => {
  const labels = navigationLabels[language === "ar" ? "ar" : "en"];

  return [
    link("dashboard", labels.dashboard, "/", DashboardIcon),
    group(
      "user-management",
      labels.userManagement,
      labels.userManagementPages,
      UserManagementIcon,
      [
        link("customers", labels.customers, "/customers"),
        link("merchants", labels.merchants, "/merchants"),
        link(
          "registration-reviews",
          labels.registrationReviews,
          "/registration-reviews"
        )
      ]
    ),
    link(
      "installment-operations",
      labels.installmentOperations,
      "/installment-operations",
      OperationsIcon
    ),
    group(
      "staff-management",
      labels.staffManagement,
      labels.staffManagementPages,
      StaffManagementIcon,
      [
        link("admins", labels.admins, "/management/admins"),
        link("roles", labels.roles, "/management/permissiongroup")
      ]
    ),
    group(
      "platform-management",
      labels.platformManagement,
      labels.platformManagementPages,
      PlatformManagementIcon,
      [
        link("global-settings", labels.globalSettings, "/globalSettings"),
        link(
          "countries-cities",
          labels.countriesCities,
          "/projects/countriescities"
        ),
        link("merchant-categories", labels.merchantCategories, "/category"),
        link(
          "merchant-payment-methods",
          labels.merchantPaymentMethods,
          "/paymentMethod"
        ),
        link("app-banners", labels.appBanners, "/media/banner")
      ]
    )
  ];
};

export const isNavigationEntryActive = (entry, pathname) => {
  if (entry.type === "group") {
    return entry.children.some((child) =>
      isNavigationEntryActive(child, pathname)
    );
  }

  return entry.path === "/"
    ? pathname === "/"
    : pathname === entry.path || pathname.startsWith(`${entry.path}/`);
};

export const findActiveNavigationGroup = (entries, pathname) =>
  entries.find(
    (entry) =>
      entry.type === "group" && isNavigationEntryActive(entry, pathname)
  )?.key || null;
